import CreditWrapper, { IProps } from './CreditWrapper';

const Credit = (props: IProps): JSX.Element => {
    return (
        <CreditWrapper {...props}/>
    );
};

export default Credit;
